import { MutationTree } from "vuex";
import { CustomerState } from "@/store/customer/type";
import { Customer } from "@/models/customer";
import { ShoppingCart } from "@/models/shopping";
import SessionService from "@/services/SessionService";

export enum CustomerMutations {
  SET_CUSTOMER = "SET_CUSTOMER",
  SET_CART = "SET_CART",
  ADD_ADDRESS = "ADD_ADDRESS",
  REMOVE_ADDRESS = "REMOVE_ADDRESS",
}

export const mutations: MutationTree<CustomerState> = {
  [CustomerMutations.SET_CUSTOMER](state: CustomerState, customer: Customer | null): void {
    state.me = customer;
    SessionService.saveCustomer(customer);
  },

  [CustomerMutations.SET_CART](state: CustomerState, cart: ShoppingCart): void {
    if (state.me) {
      state.me.shoppingCart = cart;
      SessionService.saveShoppingCart(cart);
    }
  },

  [CustomerMutations.ADD_ADDRESS](state: CustomerState, { isNew, address }): void {
    const currentUser = Customer.of({ ...state.me });
    const addressValue = address;

    if (currentUser) {
      if (isNew) {
        const addressToAdd = addressValue;

        if (currentUser.addresses && currentUser.addresses.length > 0) {
          currentUser.addresses.push(addressToAdd);
        } else {
          currentUser.addresses = [addressToAdd];
        }
      } else {
        if (currentUser.addresses && currentUser.addresses.length > 0) {
          currentUser.addresses.forEach((addressWithName, i, addresses) => {
            if (addressWithName.name === addressValue.name) {
              addresses[i] = addressValue;
            }
          });
        }
      }

      if (address.defaultShipping) {
        if (currentUser.defaultShippingAddress !== addressValue.name) {
          currentUser.defaultShippingAddress = addressValue.name;
        }
      } else if (currentUser.defaultShippingAddress === addressValue.name) {
        currentUser.defaultShippingAddress = null;
      }
      if (address.defaultBilling) {
        if (currentUser.defaultBillingAddress !== addressValue.name) {
          currentUser.defaultBillingAddress = addressValue.name;
        }
      } else if (currentUser.defaultBillingAddress === addressValue.name) {
        currentUser.defaultBillingAddress = null;
      }
      currentUser.addresses ? currentUser.addresses.sort((a, b) => {
        if (a.name && b.name) {
          return a.name < b.name ? 1 : -1;
        }
        return 0;
      }) : [];

      state.me = currentUser;
      SessionService.saveCustomer(currentUser);
    }
  },

  [CustomerMutations.REMOVE_ADDRESS](state: CustomerState, addressName): void {
    const currentUser = Customer.of({ ...state.me });

    if (currentUser && currentUser.addresses) {

      currentUser.addresses.forEach((addressWithName, i, addresses) => {
        if (addressWithName.name === addressName) {
          addresses.splice(i, 1);
        }
      });
      if (currentUser.defaultShippingAddress === addressName) {
        currentUser.defaultShippingAddress = null;
      }
      if (currentUser.defaultBillingAddress === addressName) {
        currentUser.defaultBillingAddress = null;
      }

      state.me = currentUser;
      SessionService.saveCustomer(currentUser);
    }
  },
};